import {Button, Modal} from '@ds/components';
import AddToHomeIcon from 'assets/icons/pwa/add_to_homescreen.svg';
import DakhlIcon from 'assets/icons/pwa/Dakhl_Logo.svg';
import ShareIcon from 'assets/icons/pwa/share.svg';
import {useEffect, useState} from 'react';
import {checkPwaStatus} from 'utils/Helper';

const PWAModal = () => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [isPwaInstalled, setIsPwaInstalled] = useState<boolean>(true);
  const [isIOS, setIsIOS] = useState<boolean>(false);

  const checkIsIOS = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
  };

  const showPwaModal = () => {
    sessionStorage.removeItem('pwa-modal-dismissed');
    setShowModal(true);
  };

  const hidePwaModal = () => {
    setShowModal(false);
    sessionStorage.setItem('pwa-modal-dismissed', 'true');
  };

  useEffect(() => {
    setIsIOS(checkIsIOS());
    setIsPwaInstalled(checkPwaStatus());

    const mediaQuery = window.matchMedia('(display-mode: standalone)');
    const fullscreenQuery = window.matchMedia('(display-mode: fullscreen)');

    const handleChange = () => {
      setIsPwaInstalled(checkPwaStatus());
    };

    mediaQuery.addEventListener('change', handleChange);
    fullscreenQuery.addEventListener('change', handleChange);

    window.addEventListener('focus', checkPwaStatus);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
      fullscreenQuery.removeEventListener('change', handleChange);
      window.removeEventListener('focus', checkPwaStatus);
    };
  }, []);

  useEffect(() => {
    if (!isPwaInstalled && sessionStorage.getItem('pwa-modal-dismissed') !== 'true') {
      showPwaModal();
    }
  }, [isPwaInstalled]);

  return (
    <Modal fullScreen show={showModal}>
      <div className="flex h-svh flex-1 flex-col items-center justify-center px-8">
        <div className="mb-8 flex w-full flex-col items-center gap-2">
          <img src={DakhlIcon} alt="dakhl" />
          <span className="text-subtitle-md text-gray-09">وب اپلیکیشن نما</span>
          <p className="text-body-md text-gray-07">نما را به صفحه اصلی موبایل خود اضافه کنید.</p>
        </div>
        <div className="flex w-full flex-col gap-8">
          {isIOS ? (
            <div className="flex w-full items-center gap-8">
              <img src={ShareIcon} alt="share" className="size-8 shrink-0" />
              <div className="flex flex-col gap-1">
                <span className="text-subtitle-md text-gray-09">Share</span>
                <p className="text-body-md text-gray-07">این گزینه را از نوار پایین انتخاب کنید.</p>
              </div>
            </div>
          ) : null}
          <div className="flex w-full items-center gap-8">
            <img src={AddToHomeIcon} alt="add" className="size-8 shrink-0" />
            <div className="flex flex-col gap-1">
              <span className="text-subtitle-md text-gray-09">Add to homescreen</span>
              <p className="text-body-md text-gray-07">در منوی باز شده این گزینه را انتخاب کنید.</p>
            </div>
          </div>
          <div className="flex w-full items-center gap-8">
            <img src={DakhlIcon} alt="dakhl" className="size-8 shrink-0" />
            <div className="flex flex-col gap-1">
              <span className="text-subtitle-md text-gray-09">Add</span>
              <p className="text-body-md text-gray-07">در مرحله بعدی روی این گزینه کلیک کنید.</p>
            </div>
          </div>
        </div>
        <div className="mt-24 w-full">
          <Button className="w-full" onClick={hidePwaModal}>
            متوجه شدم
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PWAModal;
